/*
 *  Author: DL
 *  Date: 2020-12-10 12:49:05
 *  Email: dunaliang@fengmap.com
 *  LastEditTime: 2020-12-10 12:50:22
 *  LastEditors: DL
 *  Description:
 *  Copyright: Copyright 2014 - 2020, FengMap, Ltd. All rights reserved.
 */

import React from 'react';

export default () => <h1>404</h1>;
